export var getToken = function (documentContext) {
    if (documentContext === void 0) { documentContext = document; }
    var tokenElement = documentContext.querySelector('meta[name="csrf-token"]');
    return tokenElement ? tokenElement.getAttribute('content') : '';
};
